import "./index.scss";
import { DiscountSort, DiscountPriceRange } from "components/UI/molecules";

export const DiscountFilters = ({
  sortList,
  sorting,
  setSorting,
  hasFilters,
  totalCount,
  priceRange,
  setPriceRange,
  setPage
}) => {
  return (
    <div className="discount-filters">
      <DiscountSort
        sortList={sortList}
        sorting={sorting}
        setSorting={setSorting}
        setPage={setPage}
      />
      <DiscountPriceRange
        hasFilters={hasFilters}
        priceRange={priceRange}
        setPriceRange={setPriceRange}
        totalCount={totalCount}
      />
    </div>
  );
};
